(function () {
	const roomJsonPath = "/wp-content/themes/leafescote/assets/rooms/rooms.json";
	fetch(roomJsonPath)
	.then(response => response.json())
	.then(data => {
		setModalLayout(data);
	});
})();

const setModalLayout = (json) => {
	const modals = document.getElementById("modals");
	
	if (modals!==null) {
		const place = document.querySelector("main").dataset.slug;
		const roomsInfo = json[place];
		const path = modals.dataset.path;
		roomsInfo.forEach(element => {
			const file = element.file;
			let type = element.type;
			if (element.id !== undefined) {
				type = element.id;
			}
			const card = `
			<div class="modal modal-fx-fadeInScale" id="${type}">
				<div class="modal-background"></div>
					<div class="modal-card">
						<header class="modal-card-head">
						</header>
						<section class="modal-card-body is-flex is-justify-content-center is-align-items-center">
							<img src="${path}${file}" alt="">
						</section>
						<footer class="modal-card-foot">
							<button class="button is-success">閉じる</button>
						</footer>
					</div>
				</div>
			</div>`;
			modals.insertAdjacentHTML('beforeend', card);
		});
		const costTable = document.querySelectorAll(".property_costs_table table tr");
		// console.log(costTable);
		costTable.forEach(element => {
			if (element.classList.length > 0) {
				const typeTd = element.children.item(1);
				let typeName = typeTd.textContent;
				if (typeTd.dataset.alt !== undefined) {
					typeName = typeTd.dataset.alt;
				}
				if (typeTd.dataset.id !== undefined) {
					typeName = typeTd.dataset.id;
				}
				typeTd.insertAdjacentHTML('beforeend', `<button class="js-modal-trigger property_modal_button" data-target="${typeName}">(間取りを見る)</button>`);
			}
		});
	};
	// Functions to open and close a modal
	function openModal($el) {
		$el.classList.add('is-active');
	}

	function closeModal($el) {
		$el.classList.remove('is-active');
	}

	function closeAllModals() {
		(document.querySelectorAll('.modal') || []).forEach(($modal) => {
			closeModal($modal);
		});
	}
	// Add a click event on buttons to open a specific modal
	(document.querySelectorAll('.js-modal-trigger') || []).forEach(($trigger) => {
		const modal = $trigger.dataset.target;
		const $target = document.getElementById(modal);

		$trigger.addEventListener('click', () => {
			openModal($target);
		});
	});

	// Add a click event on various child elements to close the parent modal
	(document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach(($close) => {
		const $target = $close.closest('.modal');

		$close.addEventListener('click', () => {
			closeModal($target);
		});
	});

	// Add a keyboard event to close all modals
	document.addEventListener('keydown', (event) => {
		const e = event || window.event;

		if (e.keyCode === 27) { // Escape key
			closeAllModals();
		}
	});
}
